module.exports = __webpack_public_path__ + "img/logo.534c73c6.png";